import { Node, mergeAttributes } from "@tiptap/core";

const NoteImage = Node.create({
    name: "noteImage",
    group: "block",
    atom: true,
    draggable: true,

    addAttributes() {
        return {
            assetId: { default: null },
            src: { default: null },
            alt: { default: "" },
            width: { default: null },
            height: { default: null },
        };
    },

    parseHTML() {
        return [{ tag: "img[data-note-image]" }];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            "img",
            mergeAttributes(HTMLAttributes, {
                "data-note-image": "true",
            }),
        ];
    },
});

export default NoteImage;
